/**
 * GA4 Ecommerce Event Tracking — Darling & Divine
 *
 * Fires standardized ecommerce events with consistent item_name
 * format across the entire funnel: view_item → add_to_cart → purchase.
 *
 * Item name format: "Product Title - Variant Title"
 * (e.g. "Eucharist Necklace - Gold")
 *
 * This replaces the inconsistent default Shopify pixel behavior
 * where view/ATC events use variant names but purchase events don't.
 */

(function () {
  'use strict';

  // ── Helpers ──────────────────────────────────────────────

  function waitForGtag(cb) {
    if (typeof gtag === 'function') return cb();
    var tries = 0;
    var poll = setInterval(function () {
      if (typeof gtag === 'function' || tries++ > 50) {
        clearInterval(poll);
        if (typeof gtag === 'function') cb();
      }
    }, 100);
  }

  /**
   * Build a consistent item_name from product title + variant title.
   * If variant is "Default Title" or matches the product title, omit it.
   */
  function buildItemName(productTitle, variantTitle) {
    if (
      !variantTitle ||
      variantTitle === 'Default Title' ||
      variantTitle === productTitle
    ) {
      return productTitle;
    }
    return productTitle + ' - ' + variantTitle;
  }

  /**
   * Build a GA4 item object from product/variant data.
   */
  function buildItem(data) {
    var item = {
      item_id: String(data.variant_id || data.product_id || ''),
      item_name: buildItemName(data.product_title, data.variant_title),
      price: data.price || 0,
      quantity: data.quantity || 1,
      currency: window.__dd_ga4_currency || 'USD'
    };
    if (data.product_type) item.item_category = data.product_type;
    if (data.vendor) item.item_brand = data.vendor;
    if (data.sku) item.item_variant = data.sku;
    if (data.index != null) item.index = data.index;
    if (data.list_name) item.item_list_name = data.list_name;
    return item;
  }

  /**
   * Send a GA4 ecommerce event. Clears prior ecommerce data first.
   */
  function sendEvent(eventName, params) {
    waitForGtag(function () {
      gtag('event', eventName, params);
    });
  }

  // ── 1. view_item (Product Page) ──────────────────────────

  function fireViewItem() {
    var el = document.getElementById('dd-ga4-product-data');
    if (!el) return;

    var data;
    try { data = JSON.parse(el.textContent); }
    catch (e) { return; }

    var item = buildItem(data);

    sendEvent('view_item', {
      currency: item.currency,
      value: item.price,
      items: [item]
    });
  }

  // ── 2. add_to_cart ───────────────────────────────────────

  function initAddToCart() {
    // Listen for the theme's custom event that fires after successful ATC
    document.addEventListener('theme:product:add', function (e) {
      var response = e.detail && e.detail.response;
      if (!response) return;

      // Shopify /cart/add.js returns the line item with full product data
      var item = buildItem({
        product_id: response.product_id,
        variant_id: response.variant_id || response.id,
        product_title: response.product_title,
        variant_title: response.variant_title,
        price: (response.final_line_price || response.price || 0) / 100,
        quantity: response.quantity || 1,
        product_type: response.product_type,
        vendor: response.vendor,
        sku: response.sku
      });

      sendEvent('add_to_cart', {
        currency: item.currency,
        value: item.price * item.quantity,
        items: [item]
      });
    });
  }

  // ── 3. view_item_list (Collection Pages) ─────────────────

  function fireViewItemList() {
    var container = document.querySelector('[data-collection-products], [data-product-grid]');
    if (!container) return;

    // Look for product data embedded by the snippet
    var els = document.querySelectorAll('.dd-ga4-grid-item');
    if (!els.length) return;

    var items = [];
    for (var i = 0; i < els.length; i++) {
      try {
        var d = JSON.parse(els[i].textContent);
        d.index = i;
        d.list_name = document.title || 'Collection';
        items.push(buildItem(d));
      } catch (e) { /* skip */ }
    }

    if (items.length) {
      sendEvent('view_item_list', {
        item_list_name: document.title || 'Collection',
        items: items
      });
    }
  }

  // ── 4. select_item (Product Card Click) ──────────────────

  function initSelectItem() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-product-link]');
      if (!link) return;

      var gridItem = link.closest('.grid-item');
      if (!gridItem) return;

      var dataEl = gridItem.querySelector('.dd-ga4-grid-item');
      if (!dataEl) return;

      try {
        var d = JSON.parse(dataEl.textContent);
        var item = buildItem(d);
        sendEvent('select_item', {
          item_list_name: document.title || 'Collection',
          items: [item]
        });
      } catch (e) { /* skip */ }
    });
  }

  // ── Init ─────────────────────────────────────────────────

  function init() {
    fireViewItem();
    initAddToCart();
    fireViewItemList();
    initSelectItem();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
